// store/modules/golfClub.js
import { RepositoryFactory } from "@/repository/RepositoryFactory";
import router from "@/router";

const golfClubRepository = RepositoryFactory.get("golfClub");

function extractYear(dateString) {
    if (!dateString) return 0;
    return dateString.includes('/')
        ? parseInt(dateString.split('/')[0], 10)
        : parseInt(dateString, 10);
}

const state = {
    golfClubData: {},
    personAwards: {},
    showSidebar: false,
    boardErrorState: null,
};
const getters = {
    golfClubData: (state) => state.golfClubData,
    personAwards: (state) => state.personAwards,
    showSidebar: (state) => state.showSidebar,
    boardErrorState: (state) => state.boardErrorState,
};

const mutations = {
    setGolfClub(state, payload) {
        state.golfClubData = payload;
    },
    setPersonAwards(state, payload) {
        state.personAwards = payload;
    },
    setSidebarState(state, payload) {
        state.showSidebar = payload;
    },
    setBoardErrorState(state, payload) {
        state.boardErrorState = payload;
    },
};

const actions = {
    async getGolfClub({ commit }, { board }) {
        try {
            let { data } = await golfClubRepository.getGolfClub(board);
            console.log('[GolfClub] API data loaded successfully, source:', navigator.onLine ? 'network' : 'cache');
            commit("setGolfClub", data);
            commit("setBoardErrorState", null);
        } catch (error) {
            console.error('[GolfClub] API call failed:', error.code, error.message);
            // Check if we have cached data in the SW cache before showing error
            if (error.code === 'ERR_NETWORK' && 'caches' in window) {
                try {
                    const cache = await caches.open('api-cache');
                    const cachedResponse = await cache.match(
                        `https://admin.creativehonourboards.co.uk/api/boardbyslug/${board}`
                    );
                    if (cachedResponse) {
                        const data = await cachedResponse.json();
                        console.log('[GolfClub] Loaded from manual cache lookup');
                        commit("setGolfClub", data);
                        commit("setBoardErrorState", null);
                        return;
                    }
                } catch (cacheError) {
                    console.error('[GolfClub] Cache lookup failed:', cacheError);
                }
            }
            if(error.code === 'ERR_NETWORK'){
                commit("setBoardErrorState", 'network-error');
            } else if(error.response?.status === 404) {
                commit("setBoardErrorState", 'invalid-board-id');
            }
            console.error("error axios", error, board);
            commit("setGolfClub", []);
        }
    },
    async getPersonAwards({ commit, state }, { personName, onSuccess }) {
        try {
            let dataAward = [];
            state.golfClubData?.awards?.forEach((award) => {
                award?.persons.forEach((person, index, tarray) => {
                    if (
                        person.name
                            .toLowerCase()
                            .includes(personName.toLowerCase())
                    ) {
                        dataAward.push({
                            name: award.name,
                            date: person.date,
                            extra: person.extra,
                            awardImage: award.imageFile,
                        });
                    }
                });
            });

            dataAward.sort((a, b) => {
                const yearA = extractYear(a.date);
                const yearB = extractYear(b.date);
                if (yearB !== yearA) return yearB - yearA;
                return (a.name || '').localeCompare(b.name || '');
            });

            commit("setPersonAwards", dataAward);
            onSuccess();
        } catch (error) {
            alert(error);
            console.error(error);
            commit("setPersonAwards", []);
        }
    },
    toggleSidebar({ commit, state }) {
        commit("setSidebarState", !state.showSidebar);
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
